/* @flow */

import React from "react";
import LogoIcon from "platopulse/components/LogoIcon";

import cx from "classnames";

type Props = {
    dark: bool,
}

const LogoBadge = ({ dark }: Props) =>
    <a href="http://platomedical.com/" target="_blank" className="h4 flex text-bold align-center no-decoration">
        <LogoIcon
            size={28}
            dark={dark}
        />
        <span className="text-small">
            <span className="ml1 text-grey-3">Powered by</span> <span className={cx({ "text-brand": !dark }, { "text-white": dark })}>Plato Pulse</span>
        </span>
    </a>

export default LogoBadge;



// WEBPACK FOOTER //
// ./public/components/LogoBadge.jsx